import Session from '../session';
import Project from '../project';

export default (function() {
    var service = {
        unsetPromises: unsetPromises,
        update: update,
    }, sessionPromise;

    Object.defineProperties(service, {
        sessionPromise: {
            get: getSessionsPromise
        },
    });

    return service;

    function getSessionsPromise() {
        if (sessionPromise) return sessionPromise;

        sessionPromise = Vue.http
            .get('accounts/user_permissions/')
            .then(handleSessionResponse);

        return sessionPromise;
    }

    function handleSessionResponse(res) {
        if (!res.body.email) return;

        var session = new Session(res.body);

        return session;
    }

    function unsetPromises() {
        sessionPromise = undefined;
    }
})();

function update(opts) {
    return Vue.http.patch('accounts/user/', opts)
        .then(function(res) {
            return res.body;
        });
}
